import { Theme } from '@mui/material/styles'

const useStyles = {
  text: (theme: Theme) => ({
    marginBottom: theme.spacing(2),
  }),
  dialogButtons: (theme: Theme) => ({
    marginTop: theme.spacing(3),
    '&:nth-of-type(1)': {
      marginRight: theme.spacing(),
    },
  }),
}
export default useStyles
